export const PlusIcon = ({ color = "#4E4E4E", size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.56986 1.44291L4.6235 1.44291L4.6235 5.19479L0.871618 5.19479V6.14115L4.6235 6.14115L4.6235 9.89303L5.56986 9.89303L5.56986 6.14115H9.32174V5.19479H5.56986L5.56986 1.44291Z"
            fill={color}
        />
    </svg>
);